import styled from 'styled-components';

const EntitiesListStatusStyles = styled.div`
  label > div {
    margin-top: 0;
  }
`;

export default EntitiesListStatusStyles;
